import { j as r } from "../../jsx-runtime-C5mzlN2N.js";
import t from "styled-components";
import "../Theme/themes.es.js";
import "../../palettes-Bw24w7AF.js";
import { getSpacings as s, getRadii as f, getEffects as g, getPaletteBorder as h, getBreakpointMediaQuery as l, getPaletteForeground as a } from "../Theme/utils.es.js";
import "react";
import "../../CssBaseline-Bp4jdUgb.js";
import { I as y } from "../../CheckIcon-XCAywhAi.js";
import "../Icon/countryVariants.es.js";
import { I as v } from "../../IconButton-g0G4rvcV.js";
import { F as $ } from "../../FileIcon-Co5mezSH.js";
import "../FeaturedIcon/constants.es.js";
const b = t.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;

  gap: ${s("xl")};
  padding: ${s("xl")};
  border-radius: ${f("xl")};
  box-shadow: ${g("shadows.xs")};
  border: 1px solid ${h("primary")};

  ${l("max", "sm")} {
    flex-wrap: wrap;
    justify-content: space-between;
  }
`, j = t($)`
  flex-shrink: 0;
  position: relative;
`, w = t.div`
  flex-grow: 1;

  ${l("max", "sm")} {
    order: 3;
    flex-basis: 100%;
  }
`, I = t(v)`
  flex-shrink: 0;

  padding: ${s("none")};
  color: ${a("quaternary.default")};
  &:hover,
  &:focus {
    color: ${a("quaternary.hover")};
  }
`, A = (o) => {
  const e = {
    color: "grayNeutral",
    icon: "alert-circle"
  };
  switch (o) {
    case "neutral":
      return e;
    case "success":
      return {
        color: "success",
        icon: "check-circle"
      };
    case "error":
      return {
        color: "error",
        icon: "alert-circle"
      };
    default:
      return e;
  }
}, O = (o) => {
  const {
    variant: e,
    children: c,
    className: d,
    footer: i,
    isOpen: p = !1,
    onClose: n,
    iconVariant: m = "modern"
  } = o;
  if (!p) return null;
  const {
    color: u,
    icon: x
  } = A(e);
  return /* @__PURE__ */ r.jsxs(b, { className: d, children: [
    /* @__PURE__ */ r.jsx(
      j,
      {
        size: "sm",
        color: u,
        variant: m,
        iconProps: { variant: x }
      }
    ),
    /* @__PURE__ */ r.jsxs(w, { children: [
      c,
      i && i
    ] }),
    n && /* @__PURE__ */ r.jsx(I, { size: "md", variant: "text", onClick: n, children: /* @__PURE__ */ r.jsx(y, { variant: "close" }) })
  ] });
};
export {
  O as default
};
